import AbstractRequestTask from '../AbstractRequestTask';

class netTask extends AbstractRequestTask {

  constructor(params) {
    super();
    this.params = params;
  }

  getUrl() {
    const urlDominioMicrofwk = window.getConfig.url_dominio_microfwk;
    return `${urlDominioMicrofwk}services/user/net/cpf_query`;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);
    
    return params;
  }

  success(data, b) {
    let isValid = super.success(data, b);
    if (!isValid) {
        let newdata = super.parseErrors(data);
        return this.reject(newdata, b);
    }
    this.resolve(data);
}
}

export default netTask;
